var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFolders = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 8V19C2 20.1 2.9 21 4 21H18M8 17H20C20.5304 17 21.0391 16.7893 21.4142 16.4142C21.7893 16.0391 22 15.5304 22 15V9C22 8.46957 21.7893 7.96086 21.4142 7.58579C21.0391 7.21071 20.5304 7 20 7H16.07C15.7406 6.9983 15.4167 6.91525 15.1271 6.75824C14.8375 6.60123 14.5912 6.37512 14.41 6.1L13.59 4.9C13.4088 4.62488 13.1625 4.39877 12.8729 4.24176C12.5833 4.08475 12.2594 4.0017 11.93 4H8C7.46957 4 6.96086 4.21071 6.58579 4.58579C6.21071 4.96086 6 5.46957 6 6V15C6 16.1 6.9 17 8 17Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolders, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folders.8521c035.svg";
export { ForwardRef as ReactComponent };